import { Box, Heading, HTMLChakraProps, Link, Stack } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { NextThinLecture } from '@/components/ui/features/lecture/LectureSuggestions/components/NextThinLecture';
import { SimilarThinLectures } from '@/components/ui/features/lecture/LectureSuggestions/components/SimilarThinLectures';
import { queryLectureSimilarRelationship, querySubsequentLecture } from '@/fetchers/thinLectures';
import { useResources, useResourceRelationship } from '@/lib/datx-jsonapi-react';
import { ThinLecture } from '@/resources/ThinLecture';
import { getEventHref } from '@/utils/getEventHref';

export const LectureSuggestions: FC<HTMLChakraProps<'div'>> = (props) => {
  const { t } = useTranslation();

  const { id } = useLecturePageQueryParams();
  const { data: nextLecture } = useResources(querySubsequentLecture(id));
  const lectureEvent = nextLecture[0]?.event;

  const { data: similarLectures } = useResourceRelationship(queryLectureSimilarRelationship(id));
  const firstSimilarLecture = similarLectures?.[0] as ThinLecture;

  return (
    <Stack spacing={4} {...props}>
      {lectureEvent ? (
        <Box>
          <Heading fontSize="xl" lineHeight={7} color="gray.900" py={5}>
            {t('lecture.nextFrom')}
            <NextLink href={getEventHref(lectureEvent)} passHref legacyBehavior>
              <Link>{`${lectureEvent?.name || ''}`}</Link>
            </NextLink>
          </Heading>

          <NextThinLecture />
        </Box>
      ) : null}
      {firstSimilarLecture ? (
        <Box>
          <Heading fontSize="xl" lineHeight={7} color="gray.900" py={5}>
            {t('lecture.similarLecture')}
          </Heading>
          <SimilarThinLectures />
        </Box>
      ) : null}
    </Stack>
  );
};
